import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { t } from "../translations";

interface EndConversationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  language: string;
}

export const EndConversationDialog: React.FC<EndConversationDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  language,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderRadius: "16px",
          padding: "24px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", paddingBottom: "8px" }}>
        {t("endConversationTitle", language)}
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", paddingTop: "8px" }}>
        <Typography variant="body1" color="text.secondary">
          {t("endConversationMessage", language)}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: "12px",
          paddingTop: "16px",
        }}
      >
        <button
          className="action-button secondary"
          onClick={onCancel}
          style={{ minWidth: "120px" }}
        >
          {t("continue", language)}
        </button>
        <button
          className="action-button"
          onClick={onConfirm}
          style={{ minWidth: "120px" }}
        >
          {t("end", language)}
        </button>
      </DialogActions>
    </Dialog>
  );
};
